// extracted by mini-css-extract-plugin
export default {"button":"ColumnButton_button__y5geu"};